import React from "react";

import { Row, Col, Form } from "react-bootstrap";

import DatePicker from "./date-picker";

import { format as formatDate } from "../../../utils/date";
import { deepEqual } from "../../../utils/object";

class DateRange extends React.Component {
    /**
     *
     */
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default ?? {},
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }

    componentDidUpdate = (oldProps) => {
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default;
        if (deepEqual(this.state.data, newData)) return;
        
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
    }

    onChange = (e) => {
        const result = { 
            ...this.state.data,
            [e.target.name]: e.target.value
        };

        if (result === this.state.data) return;

        this.setState({
            data: result
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    onStartDateChange = (val) => {
        const name = this.state.configuration.start.key;
        this.onChange({ target: { name, value: val } });
    }
    
    onEndDateChange = (val) => {
        const name = this.state.configuration.end.key;
        this.onChange({ target: { name, value: val } });
    }

    data = (key) => {
        try {
            return this.state.data[key];
        } catch { }
        return null;
    }

    render() {
        return (
            
            <>
                <Row>
                    <Col sm="5">
                        <div className="mb-3 top-label">
                            {(this.state.locked) ?
                                <Form.Control type="text" name={this.state.configuration.start.key} value={formatDate(this.data(this.state.configuration.start.key)) || ""} readOnly={true} />
                                :
                                <DatePicker className="form-control" selected={this.data(this.state.configuration.start.key)} onChange={this.onStartDateChange} placeholder="" name={this.state.configuration.start.key} />
                            }
                            <Form.Label>{this.state.configuration.start.label}</Form.Label>
                        </div>
                    </Col>
                    <Col md="1" className="d-md-block text-center"><span style={{ top: "15px", position: "relative" }}>to</span></Col>
                    <Col md="6">
                        <div className="mb-3 top-label">
                            {(this.state.locked) ?
                                <Form.Control type="text" name={this.state.configuration.end.key} value={formatDate(this.data(this.state.configuration.end.key)) || ""} readOnly={true} />
                                :
                                <DatePicker className="form-control" selected={this.data(this.state.configuration.end.key)} onChange={this.onEndDateChange} placeholder="" name={this.state.configuration.end.key} />
                            }
                            <Form.Label>{this.state.configuration.end.label}</Form.Label>
                        </div>
                    </Col>
                </Row>
            </>
        )
    }
}

export default DateRange;